import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IoIosArrowRoundUp, IoIosArrowRoundDown } from 'react-icons/io';
import styles from './Table.module.css';
const TableSortIcon = ({ isSortable, sortDirection, showSortIcons = true, isActive }) => {
    let sortIcons = [];
    if (isSortable && showSortIcons) {
        if (!isActive) {
            sortIcons = [
                _jsx(IoIosArrowRoundUp, { className: styles.sortArrow, size: 16 }, void 0),
                _jsx(IoIosArrowRoundDown, { className: styles.sortArrow, size: 16 }, void 0),
            ];
        }
        else if (sortDirection === 'asc') {
            sortIcons = [
                _jsx(IoIosArrowRoundDown, { className: styles.sortArrow, size: 16 }, void 0),
            ];
        }
        else {
            sortIcons = [
                _jsx(IoIosArrowRoundUp, { className: styles.sortArrow, size: 16 }, void 0),
            ];
        }
    }
    if (isSortable) {
        return (_jsxs("div", Object.assign({ className: styles.sortIconBar }, { children: [_jsx("span", Object.assign({ className: styles.sortIcon }, { children: sortIcons[0] }), void 0), _jsx("span", Object.assign({ className: styles.sortIcon }, { children: sortIcons[1] }), void 0)] }), void 0));
    }
    return null;
};
export default TableSortIcon;
